import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CallSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CallSVG;
